module.exports = __webpack_public_path__ + "static/media/team2.8152c078.webp";